import ZwxIpc from './Index.vue'
import ZwxFastreport from './fastreport/Index.vue'
import ZwxSignature from './signature/Index.vue'

ZwxIpc.install = function(Vue) {
  Vue.component(ZwxIpc.name, ZwxIpc)
}

ZwxFastreport.install = function(Vue) {
  Vue.component(ZwxFastreport.name, ZwxFastreport)
}

ZwxSignature.install = function(Vue) {
  Vue.component(ZwxSignature.name, ZwxSignature)
}

export default [ZwxIpc, ZwxFastreport, ZwxSignature]
